<div class="login-page">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div>
